import { render, staticRenderFns } from "./LessonComponent.vue?vue&type=template&id=297d5c8c&scoped=true&"
import script from "./LessonComponent.vue?vue&type=script&lang=js&"
export * from "./LessonComponent.vue?vue&type=script&lang=js&"
import style0 from "./LessonComponent.vue?vue&type=style&index=0&id=297d5c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297d5c8c",
  null
  
)

export default component.exports